/**
 * Guards every query-string-driven post-auth redirect (login hand-back,
 * cluster-terms acceptance) against becoming an open redirect. Only a
 * same-app relative path is safe: an absolute URL, a protocol-relative
 * `//host` URL, and a backslash-prefixed variant such as `/\host` or
 * `\\host` are all refused — browsers normalise a leading `[/\\]{2,}` run to
 * protocol-relative, same as `//host`. So is whitespace straight after the
 * leading slash, which browsers strip (a tab or newline) before reading what
 * follows as a host.
 */
export const isSafeRedirectPath = (path: unknown): path is string =>
  typeof path === 'string' && path.startsWith('/') && !/^\/[\s/\\]/.test(path);
